var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9545fb",
    fillRule: "evenodd",
    d: "m12.941 9.752-3.97 3.97a.75.75 0 1 0 1.061 1.06l5.245-5.245a.76.76 0 0 0 0-1.071L10.032 3.22a.75.75 0 0 0-1.06 1.06l3.969 3.97H4.205c-.389 0-.703.336-.703.75 0 .415.314.75.703.75z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRight;